import toInteger from "../_lib/toInteger/index.mjs";
import addMilliseconds from "../addMilliseconds/index.mjs";
import requiredArgs from "../_lib/requiredArgs/index.mjs";
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
export {
  addHours as default
};
